import React, { useEffect, useRef } from 'react';

function Contact() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const fadeInObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            });
        }, observerOptions);

        if (sectionRef.current) {
            sectionRef.current.style.opacity = '0';
            sectionRef.current.style.transform = 'translateY(30px)';
            sectionRef.current.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
            fadeInObserver.observe(sectionRef.current);
        }

        return () => fadeInObserver.disconnect();
    }, []);

    return (
        <section className="contact-section" id="contact" ref={sectionRef}>
            <div className="container">
                <h2 className="section-title">CONTACT US</h2>
                <div className="contact-info">
                    <div className="contact-item">
                        <h3>EMAIL</h3>
                        <p>sales@rainbowcraft.ae</p>
                    </div>
                    <div className="contact-item">
                        <h3>PHONE</h3>
                        <p>+971 50 860 4485</p>
                    </div>
                    <div className="contact-item">
                        <h3>ADDRESS</h3>
                        <p>Musaffah, Abu Dhabi, UAE</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;
